import { render } from "./page-recomend-qrcode.vue?vue&type=template&id=e2bbdb6e&scoped=true"
import script from "./page-recomend-qrcode.vue?vue&type=script&lang=js"
export * from "./page-recomend-qrcode.vue?vue&type=script&lang=js"

import "./page-recomend-qrcode.vue?vue&type=style&index=0&id=e2bbdb6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2bbdb6e"]])

export default __exports__